import mailStore from '../store/Store';
export default function selectMailStoreItemById(itemId) {
    return mailStore.items.get(itemId);
}
//# sourceMappingURL=selectMailStoreItemById.js.map